import { useCallback } from 'react'

import { useSegment } from '../../../../../hooks'
import { useSandboxModeContext } from '../contexts/sandboxModeContext'

/**
 * Wraps useSegment's track() so sandbox-only actions never pollute real analytics data.
 * useSegment itself has no suppression mechanism and shouldn't be touched (it's used
 * app-wide), so gating happens here instead — call sites in this page tree should route
 * tracking calls through this hook rather than useSegment directly.
 */
export const useSandboxAwareTrack = () => {
  const sandbox = useSandboxModeContext()
  const { track: trackReal } = useSegment()

  const track = useCallback(
    (...args: Parameters<typeof trackReal>) => {
      if (sandbox) {
        return
      }

      trackReal(...args)
    },
    [sandbox, trackReal],
  )

  return { track }
}
